import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { time_id: '', nome: '', apelido: '' };

export default function AdminJogadores() {
  const [cidades, setCidades] = useState([]);
  const [cidadeSel, setCidadeSel] = useState('');
  const [times, setTimes] = useState([]);
  const [jogadores, setJogadores] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { api.get('/cidades/todas').then(setCidades).catch(() => {}); }, []);

  useEffect(() => {
    if (!cidadeSel) { setTimes([]); setJogadores([]); return; }
    api.get(`/jogadores/times-por-cidade/${cidadeSel}`).then(setTimes).catch(() => {});
    carregarJogadores();
  }, [cidadeSel]);

  function carregarJogadores() {
    api.get(`/jogadores?cidade_id=${cidadeSel}`).then(setJogadores).catch(() => {});
  }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      if (editando) { await api.put(`/jogadores/${editando.id}`, { ...form, ativo: editando.ativo }); }
      else { await api.post('/jogadores', form); }
      setMsg('Salvo com sucesso!'); setForm(empty); setEditando(null); carregarJogadores();
    } catch (err) { setMsg(err.message); }
  }

  async function alternarAtivo(j) {
    await api.put(`/jogadores/${j.id}`, { time_id: j.time_id, nome: j.nome, apelido: j.apelido, ativo: j.ativo ? 0 : 1 });
    carregarJogadores();
  }

  async function deletar(id) {
    if (!window.confirm('Remover este jogador?')) return;
    await api.delete(`/jogadores/${id}`); carregarJogadores();
  }

  return (
    <div>
      <h2 className="admin-title">Jogadores</h2>
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="form-group">
        <label>Cidade</label>
        <select value={cidadeSel} onChange={e => { setCidadeSel(e.target.value); setEditando(null); setForm(empty); }}>
          <option value="">Selecione</option>
          {cidades.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      {cidadeSel && (
        <form onSubmit={salvar} className="admin-form">
          <h3>{editando ? 'Editar Jogador' : 'Novo Jogador'}</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Time</label>
              <select value={form.time_id} onChange={e => setForm({ ...form, time_id: e.target.value })} required>
                <option value="">Selecione</option>
                {times.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required /></div>
            <div className="form-group"><label>Apelido (opcional)</label><input value={form.apelido} onChange={e => setForm({ ...form, apelido: e.target.value })} /></div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Salvar</button>
            {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm(empty); }}>Cancelar</button>}
          </div>
        </form>
      )}

      {cidadeSel && (
        <div className="admin-table-wrap">
          <table>
            <thead><tr><th>Nome</th><th>Apelido</th><th>Time</th><th>Ativo</th><th>Ações</th></tr></thead>
            <tbody>
              {jogadores.map(j => (
                <tr key={j.id}>
                  <td>{j.nome}</td>
                  <td>{j.apelido || '—'}</td>
                  <td>{j.time_nome}</td>
                  <td>{j.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                  <td>
                    <div className="admin-actions">
                      <button className="btn btn-secondary" onClick={() => { setEditando(j); setForm({ time_id: j.time_id, nome: j.nome, apelido: j.apelido || '' }); }}>Editar</button>
                      <button className="btn btn-secondary" onClick={() => alternarAtivo(j)}>{j.ativo ? 'Desativar' : 'Ativar'}</button>
                      <button className="btn btn-danger" onClick={() => deletar(j.id)}>Remover</button>
                    </div>
                  </td>
                </tr>
              ))}
              {jogadores.length === 0 && <tr><td colSpan={5}>Nenhum jogador cadastrado.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
